export default __webpack_public_path__ + "static/media/FRASES_08.a4bf6b21.png";